import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import config from "./Configurations";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import store from "redux/store";
import "./i18next";
import { queryClient } from "./queryClient";
import { unregisterPwaServiceWorker } from "./serviceWorkerRegistration";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fortawesome/fontawesome-free/css/v4-shims.min.css";
import "@tabler/icons-webfont/dist/tabler-icons.min.css";

// Shared SPA entry: /login, /signup, /console. Empty GTM_ID = no tag.
if (config.GTM_ID) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "gtm.js",
    "gtm.start": new Date().getTime(),
  });
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(
    config.GTM_ID
  )}`;
  document.head.appendChild(script);
}

// window.less.modifyVars({
//   "@primary-color": "#100D31",
// });
// window.less.refreshStyles();

// const themes = {
//   dark: `${process.env.PUBLIC_URL}/dark-theme.css`,
//   light: `${process.env.PUBLIC_URL}/light-theme.css`,
// }

ReactDOM.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<div>Loading...</div>}>
        <App />
      </Suspense>
    </QueryClientProvider>
  </Provider>,
  document.getElementById("root"),
);

unregisterPwaServiceWorker();
